import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import Bundle from '@saucelabs/sl-component-bundle';

import PerformanceMainContainer from './containers/PerformanceMainContainer';

const performanceReport = () => import(/* webpackChunkName: "performance-report" */ './containers/PerformanceReportContainer');
const performanceHistory = () => import(/* webpackChunkName: "performance-history" */ './containers/PerformanceHistoryContainer');

const PerformanceRoutes = ({ match }) => (
  <Switch>
    <Route
      exact
      path={`${match.url}/:jobId/:pageIndex/history`}
      render={(props) => (
        <PerformanceMainContainer>
          <Bundle load={performanceHistory}>
            {(Component) => <Component {...props} />}
          </Bundle>
        </PerformanceMainContainer>
      )}
    />
    <Route
      exact
      path={`${match.url}/:jobId/:pageIndex`}
      render={(props) => (
        <PerformanceMainContainer>
          <Bundle load={performanceReport}>
            {(Component) => <Component {...props} />}
          </Bundle>
        </PerformanceMainContainer>
      )}
    />
  </Switch>
);

PerformanceRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default PerformanceRoutes;
export { PerformanceRoutes };
